import React, { useEffect } from "react";
import { Grid, InputLabel, Box, Link, FormControl, Select, MenuItem } from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import CreateIcon from '@mui/icons-material/Create';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AddIcon from '@mui/icons-material/AddCircle';
import TextField from '../../TextField';

import { chapter as chapterConst, SECTION_TYPE } from '../../../pages/course/lessonPlan/constants';
import { Chapter } from "./Chapter";
import SearchableSelect from '../../SearchableSelect';
import Button from '../../Button';
import { useCourse } from '../../../pages/course/hooks';
import { generateUUID } from "../../../utils";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

export const Section = ({ data, handleAssessmentClick, pageType }) => {
    const { id } = useParams();
    const { updateLessonPlan, lessonPlan, setChapters, updateSection, deleteAssessment } = useCourse();
    const [expanded, setExpanded] = React.useState(false);
    const [section, setSection] = React.useState(data);
    const [prerequisites, setPrerequisites] = React.useState(data?.prerequisites || []);
    const [chapterTypes, setChapterTypes] = React.useState([])
    const [assessments, setAssessments] = React.useState([]);
    const [type, setType] = React.useState();

    useEffect(() => {
        const url = window.location.pathname;
        const lastPart = url.substring(url.lastIndexOf('/') + 1);
        setType(lastPart)
    }, [])
    React.useEffect(() => {
        if (section.assessments) {
            setAssessments(section.assessments);
        }
    }, [lessonPlan]);

    // useEffect(() => {
    //     if (section) {
    //         onSave();
    //     }
    // }, [section]);

    const removeAssessment = (assessment) => {
        if (!confirm('Are you sure to delete this assessment?')) { return; }
        deleteAssessment({ id: assessment?.id })
    }

    const handleExpansion = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const prerequisitesOnChange = (e, value) => {
        setPrerequisites((prev) => ([...new Set([...prev, ...(value.map(e => e.name))])]));
        onSave(section)
    }

    const removeSection = (name) => {
        let sects = lessonPlan?.sections?.filter(e => e.name != name) || [];
        updateLessonPlan({ sections: sects });
        // onSave()
    }

    const onSave = async (sectionDetails) => {
        // setSection(section);  
        updateSection({ ...section, id: section.sectionId || generateUUID(), prerequisites });
        // setExpanded(false);

    }

    const handleChange = async (e) => {
        const { name, value } = e.target;
        const updatedSection = {
            ...section,
            [name]: value
        }
        setSection((prev => updatedSection));
        // onSave(updatedSection)
        updateSection({ ...updatedSection, id: section.sectionId || generateUUID(), prerequisites });
    }


    const addChapter = (name) => {
        const sections = (lessonPlan?.sections || []).map(e => e);
        let ind = sections.findIndex(e => e.name == name);
        if (ind < 0) return;

        let section = sections[ind], chapters = (section.chapters || []);
        if (!section?.sectionType) {
            return toast.warn('Please select Session Type to Add Chapter');
        }
        let chapter = {
            name: `Session ${chapters.length + 1}`,
            type: chapterConst.TYPES.Reading,
            sequence: 1,
            contentURL: '',
            assessments: [],
            contentType: chapterConst.CONTENT_TYPES.Text,
            description: '',
            chapterId: generateUUID(),
        }

        if (chapters.length) {
            chapter.sequence = (chapters.length + 1);
        }

        setChapters({ name, chapters: [...chapters, chapter] });
    }

    React.useEffect(() => {
        let _sec = lessonPlan?.sections?.find(e => e.sectionId == section.sectionId) || {};
        if (_sec && _sec.chapters && _sec.chapters.length) {
            setSection(prev => ({ ...prev, chapters: _sec.chapters }))
        }
    }, [lessonPlan]);

    const cancelChanges = () => {
        setExpanded(false);
        setSection(data)
    }

    return (
        <Accordion onChange={handleExpansion(data.name)}
            sx={{
                boxShadow: 'none',
            }}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                sx={{
                    background: 'var(--mui-palette-gray-lightGray50)',
                    boxShadow: 'none',
                    borderRadius: '4px',
                    minHeight: '48px !important',
                    '& .Mui-expanded': {
                        margin: '12px 0 !important',
                    }
                }}
            >
                <Box sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',

                }}>
                    <Box sx={{ color: 'var(--mui-palette-primary-blue)', width: '80%', fontWeight: 'bold' }}>{section?.name}</Box>
                    <Button sx={{ color: 'var(--mui-palette-primary-blue)', p: 0 }} onClick={() => removeSection(section?.name)} variant='text' placeholder={
                        <Link title="Delete Chapter" sx={{ color: 'var(--mui-palette-primary-blue)' }}><DeleteIcon /> </Link>
                    } />
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                <Grid sx={{ mt: 1 }} container alignItems="center" spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <InputLabel style={styles.inputLabel}>Name <span style={{ color: 'red' }}>*</span></InputLabel>
                        <TextField
                            name="name"
                            fullWidth
                            value={section?.name}
                            size='large'
                            onChange={handleChange}
                            placeholder="Enter session name"
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputLabel style={styles.inputLabel}>Prerequisites</InputLabel>
                        <SearchableSelect
                            data={(lessonPlan.sections || []).filter(e => e.name != section?.name).map(e => ({ ...e, id: e.sectionId || generateUUID() }))}
                            onChange={prerequisitesOnChange}
                            multiple={true}
                            defaultValue={(prerequisites || []).map(e => ({ name: e, id: generateUUID() }))}
                            getOptionLabel={(opt) => opt.name}
                            sx={{
                                height: '47px',
                                '& .MuiInputBase-root': {
                                    height: '47px',
                                }
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputLabel style={styles.inputLabel}>Chapter Type <span style={{ color: 'red' }}>*</span></InputLabel>
                        <FormControl fullWidth>
                            <Select
                                name="sectionType"
                                value={section?.sectionType}
                                onChange={handleChange}
                                sx={{
                                    height: '47px',
                                    '& .MuiInputBase-root': {
                                        height: '47px',
                                    }
                                }}
                            >
                                {SECTION_TYPE.map((type, i) => <MenuItem key={i} value={type.sectionType}>{type.sectionType}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    {/* <Grid item xs={12}>
                        <InputLabel style={styles.inputLabel}>Description</InputLabel>
                        <TextField
                            name="description"
                            fullWidth
                            multiline
                            rows={3}
                            value={section?.description}
                            onChange={handleChange}
                            placeholder="Enter section description"
                            required
                        />
                    </Grid> */}
                    <AccordionActions sx={{ p: 2, justifyContent: 'flex-end', display: 'flex', width: '100%' }}>

                        {/* {expanded && (
                            <>
                                <Button onClick={() => cancelChanges()} variant='outlined' placeholder={'Cancel'} />
                                <Button onClick={onSave} variant='contained' placeholder={'Save'} />
                            </>
                        )} */}

                    </AccordionActions>

                    {/* ----------------- session assessments------------------  */}

                    {/* {lessonPlan.id && <Grid item xs={12}>
                        <Accordion sx={{
                            boxShadow: 'none',
                            border: '1px solid var(--mui-palette-gray-lightGray50)',
                            borderRadius: '4px',
                        }} >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                                sx={{
                                    background: 'var(--mui-palette-gray-lightGray50)',
                                    boxShadow: 'none',
                                    borderRadius: '4px',
                                    minHeight: '48px !important',
                                    '& .Mui-expanded': {
                                        margin: '12px 0 !important',
                                    }
                                }}
                            ><Box sx={{ color: 'var(--mui-palette-primary-blue)', width: '80%', fontWeight: 'bold' }}>Session Assessments</Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                {assessments?.map((assessment, i) => {
                                    return (
                                        <Box key={assessment?.id} sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            background: 'var(--mui-palette-gray-lightGray50)',
                                            alignItems: 'center',
                                            p: 1,
                                            mt: 2,
                                            borderRadius: '5px',
                                        }}>{assessment?.name}
                                            <div style={styles.actionBtn} >
                                                <Link style={styles.assessmentsLink} href={`lesson-plan/${lessonPlan.id}/assessments/section/${section.sectionId}/edit/${assessment?.id}`} title="Edit Assessment">
                                                    <CreateIcon sx={{ color: 'var(--mui-palette-primary-button)', fontSize: '1.2rem' }}
                                                        onClick={() => { handleAssessmentClick(`/courses/${id}/lesson-plan/${lessonPlan.id}/assessments/section/${section.sectionId}/edit/${assessment?.id}`) }}
                                                    />
                                                </Link>
                                                <Button sx={{ color: 'var(--mui-palette-primary-blue)', p: 0 }} variant='text' onClick={() => removeAssessment(assessment)} placeholder={<DeleteIcon />} />
                                            </div>
                                        </Box>
                                    )
                                })}
                                {!assessments?.length > 0 && pageType === 'view' &&
                                    <Link style={styles.assessmentsLink} href={`lesson-plan/${lessonPlan.id}/assessments/section/${section?.sectionId}/create`}>Create Assessment <ArrowForwardIcon sx={{ ml: 1 }} /></Link>}
                            </AccordionDetails>
                        </Accordion>
                    </Grid>} */}

                    <Grid item xs={12}
                        sx={{
                            p: '8px 10px !important',
                            display: 'flex',
                            justifyContent: 'space-between',
                            background: '#FFB733',
                            borderRadius: '5px',
                            mt: 4,
                            mb: 2,
                            mx: 2
                        }}>
                        <InputLabel
                            sx={{
                                color: 'var(--mui-palette-common-white)',
                                fontSize: '1.2em',
                                fontWeight: '500',
                            }}>Sessions</InputLabel>
                        <Button sx={{ p: 0, color: 'var(--mui-palette-common-white)', minWidth: '30px' }} onClick={() => addChapter(data.name)} placeholder={
                            <Link title="Add Session" sx={{ color: 'var(--mui-palette-primary-contrastText)' }}><AddIcon /> </Link>
                        } variant='text' />
                    </Grid>
                    <Grid xs={12} sx={{ my: 0, p: 0, mx: 2 }}>
                        {data.chapters && data.chapters.map((e, i) => <Chapter key={e.chapterId || i} section={section} data={e} />)}
                    </Grid>
                </Grid>
            </AccordionDetails>
            {/* <AccordionActions sx={{ px: 4, py: 2 }}>
                {expanded && edit && (
                    <>
                        <Button onClick={() => cancelChanges()} variant='outlined' placeholder={'Cancel'} />
                        <Button onClick={onSave} variant='contained' placeholder={'Save'} />
                    </>
                )}
            </AccordionActions> */}
        </Accordion>
    )
}

const styles = {
    label: {
        color: 'var(--mui-palette-common-black)',
        fontWeight: 'bold'
    },
    inputLabel: {
        color: 'var(--mui-palette-primary-darkGrey)',
        marginBottom: '5px',
        fontWeight: '600',
        fontSize: '14px'

    },
    assessmentsLink: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '5px'
    },
    actionBtn: {
        display: 'flex',
        alignItems: 'center'
    }
}